<ng-container>

  <div class="flex-container">
    <div class="width100">
      <span class="text-center">Importar cuadro de amortización ( Excel )</span>
      <hr>
    </div>

    <div class="width100 text-center">

      <label for="img-input" class="pic-hover me-4">
        <span class="black-text">Seleccionar Excel</span>
      </label>
      <input matinput id="img-input" type="file" (change)="uploadFile($event)" placeholder="Upload file" accept=".xlsx">

    </div>

    <div class="width100 text-center mt-5">
      <ng-container *ngIf="loadingFile">
        <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
      </ng-container>
    </div>
  </div>

</ng-container>
